module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _Stateful = __webpack_require__(2);
    Object.defineProperty(exports, "default", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Stateful).default;
        }
    });
    var _Stateless = __webpack_require__(9);
    Object.defineProperty(exports, "FieldBaseStateless", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Stateless).default;
        }
    });
    var _Label = __webpack_require__(19);
    Object.defineProperty(exports, "Label", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Label).default;
        }
    });
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function waitForRender(cb) {
        // Execute the callback after any upcoming render calls in the execution queue
        setTimeout(cb, 0);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(3), _extends3 = _interopRequireDefault(_extends2), _classCallCheck2 = __webpack_require__(4), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(5), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(6), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(8), _propTypes2 = _interopRequireDefault(_propTypes), _Stateless = __webpack_require__(9), _Stateless2 = _interopRequireDefault(_Stateless), ON_BLUR_KEY = "onBlurKey", ON_CONTENT_BLUR_KEY = "onContentBlurKey", FieldBase = function(_PureComponent) {
        function FieldBase() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, FieldBase);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.state = {
                isFocused: _this.props.defaultIsFocused,
                isDialogFocused: !1,
                shouldIgnoreNextDialogBlur: !1
            }, _this.onFocus = function(e) {
                _this.setState({
                    isFocused: !0
                }), _this.props.onFocus(e), // Escape from a possible race-condition when blur and focus happen one by one
                // (otherwise the dialog might be left closed)
                _this.cancelSchedule(ON_BLUR_KEY);
            }, _this.onBlur = function(e) {
                // Because the blur event fires before the focus event, we want to make sure that we don't
                // render and close the dialog before we can check if the dialog is focused.
                _this.reschedule(ON_BLUR_KEY, function() {
                    return _this.setState({
                        isFocused: !1
                    });
                }), _this.props.onBlur(e);
            }, _this.onContentFocus = function() {
                _this.state.isDialogFocused ? // If we are tabbing between two elements in the warning dialog, we need to prevent the
                // dialog from closing.
                _this.setState({
                    shouldIgnoreNextDialogBlur: !0
                }) : _this.setState({
                    isDialogFocused: !0
                }), // Escape from a possible race-condition when blur and focus happen one by one
                // (otherwise the dialog might be left closed)
                _this.cancelSchedule(ON_CONTENT_BLUR_KEY);
            }, _this.onContentBlur = function() {
                waitForRender(function() {
                    _this.state.shouldIgnoreNextDialogBlur ? // Ignore the blur event if we are still focused in the dialog.
                    _this.setState({
                        shouldIgnoreNextDialogBlur: !1
                    }) : _this.setState({
                        isDialogFocused: !1
                    });
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(FieldBase, _PureComponent), FieldBase.prototype.cancelSchedule = function(key) {
            this.timers = this.timers || {}, this.timers[key] && (clearTimeout(this.timers[key]), 
            delete this.timers[key]);
        }, FieldBase.prototype.reschedule = function(key, callback) {
            var _this2 = this;
            // Use reschedule (not just schedule) to avoid race conditions when multiple blur events
            // happen one by one.
            this.timers = this.timers || {}, this.cancelSchedule(key), this.timers[key] = setTimeout(function() {
                callback(), _this2.cancelSchedule(key);
            }, 0);
        }, FieldBase.prototype.render = function() {
            var _state = this.state, isFocused = _state.isFocused, isDialogFocused = _state.isDialogFocused;
            return _react2.default.createElement(_Stateless2.default, (0, _extends3.default)({}, this.props, {
                isDialogOpen: isFocused || isDialogFocused,
                isFocused: isFocused,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                onDialogFocus: this.onContentFocus,
                onDialogBlur: this.onContentBlur
            }));
        }, FieldBase;
    }(_react.PureComponent);
    FieldBase.propTypes = {
        /** focus the element when initially rendered */
        defaultIsFocused: _propTypes2.default.bool,
        /** focus event handler */
        onFocus: _propTypes2.default.func,
        /** blur event handler */
        onBlur: _propTypes2.default.func
    }, FieldBase.defaultProps = {
        defaultIsFocused: !1,
        onFocus: function() {},
        onBlur: function() {}
    }, exports.default = FieldBase;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 9 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(4), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(5), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(6), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(10), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  max-width: 100%;\n" ], [ "\n  ", "\n  max-width: 100%;\n" ]), _propTypes = __webpack_require__(8), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(11), _styledComponents2 = _interopRequireDefault(_styledComponents), _inlineDialog = __webpack_require__(12), _inlineDialog2 = _interopRequireDefault(_inlineDialog), _Content = __webpack_require__(13), _ValidationElement = __webpack_require__(16), _ValidationElement2 = _interopRequireDefault(_ValidationElement), DialogWrapper = _styledComponents2.default.div(_templateObject, function(p) {
        return p.grow ? "flex: 1 1 auto;" : "";
    }), FieldBaseStateless = function(_PureComponent) {
        function FieldBaseStateless() {
            return (0, _classCallCheck3.default)(this, FieldBaseStateless), (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
        }
        return (0, _inherits3.default)(FieldBaseStateless, _PureComponent), FieldBaseStateless.prototype.componentDidUpdate = function() {
            this.props.shouldReset && this.props.onBlur();
        }, FieldBaseStateless.prototype.render = function() {
            function getAppearance(a) {
                return isDisabled ? "disabled" : isInvalid ? "invalid" : a;
            }
            var _props = this.props, appearance = _props.appearance, children = _props.children, invalidMessage = _props.invalidMessage, isCompact = _props.isCompact, isDialogOpen = _props.isDialogOpen, isDisabled = _props.isDisabled, isFitContainerWidthEnabled = _props.isFitContainerWidthEnabled, isFocused = _props.isFocused, isInvalid = _props.isInvalid, isLoading = _props.isLoading, isPaddingDisabled = _props.isPaddingDisabled, isReadOnly = _props.isReadOnly, onBlur = _props.onBlur, onDialogBlur = _props.onDialogBlur, onDialogClick = _props.onDialogClick, onDialogFocus = _props.onDialogFocus, onFocus = _props.onFocus;
            return _react2.default.createElement(_Content.ContentWrapper, {
                disabled: isDisabled,
                grow: isFitContainerWidthEnabled
            }, _react2.default.createElement(DialogWrapper, {
                grow: isFitContainerWidthEnabled
            }, _react2.default.createElement(_inlineDialog2.default, {
                content: invalidMessage,
                isOpen: isDialogOpen && !!invalidMessage,
                onContentBlur: onDialogBlur,
                onContentClick: onDialogClick,
                onContentFocus: onDialogFocus,
                position: "right middle",
                shouldFlip: [ "top" ]
            }, _react2.default.createElement(_Content.Content, {
                appearance: getAppearance(appearance),
                compact: isCompact,
                disabled: isDisabled,
                fitContainerWidth: isFitContainerWidthEnabled,
                focused: isFocused,
                invalid: isInvalid && !isFocused,
                none: "none" === appearance,
                onBlurCapture: onBlur,
                onFocusCapture: onFocus,
                paddingDisabled: isPaddingDisabled,
                readOnly: isReadOnly,
                subtle: "subtle" === appearance
            }, children, _react2.default.createElement(_ValidationElement2.default, {
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                isLoading: isLoading
            })))));
        }, FieldBaseStateless;
    }(_react.PureComponent);
    FieldBaseStateless.propTypes = {
        /**
	    * controls the appearance of the field.
	    * subtle shows styling on hover.
	    * none hides all field styling.
	    */
        appearance: _propTypes2.default.oneOf([ "standard", "none", "subtle" ]),
        /** children to render as dialog */
        children: _propTypes2.default.node,
        /** message to show on the dialog when isInvalid and isDialogOpen  are true */
        invalidMessage: _propTypes2.default.node,
        /** applies compact styling, making the field smaller */
        isCompact: _propTypes2.default.bool,
        /** controls whether to show or hide the dialog */
        isDialogOpen: _propTypes2.default.bool,
        /** disable the field and apply disabled styling */
        isDisabled: _propTypes2.default.bool,
        /** whether the fit the field to the enclosing container */
        isFitContainerWidthEnabled: _propTypes2.default.bool,
        /** apply styling based on whether the field is focused */
        isFocused: _propTypes2.default.bool,
        /** set the field as invalid, triggering style and message */
        isInvalid: _propTypes2.default.bool,
        /** show a loading indicator */
        isLoading: _propTypes2.default.bool,
        /** disable padding styles */
        isPaddingDisabled: _propTypes2.default.bool,
        /** apply read only styling */
        isReadOnly: _propTypes2.default.bool,
        /** mark the field as required */
        isRequired: _propTypes2.default.bool,
        /** handler for the onBlur event on the field element */
        onBlur: _propTypes2.default.func.isRequired,
        /** handler for the onBlur event on the dialog element */
        onDialogBlur: _propTypes2.default.func,
        /** handler for the click event on the dialog element */
        onDialogClick: _propTypes2.default.func,
        /** handler for the focus event on the dialog element */
        onDialogFocus: _propTypes2.default.func,
        /** handler for the focus event on the field element */
        onFocus: _propTypes2.default.func.isRequired,
        /** whether to call the onBlur handler inside componentDidUpdate */
        shouldReset: _propTypes2.default.bool
    }, FieldBaseStateless.defaultProps = {
        appearance: "standard",
        invalidMessage: "",
        isCompact: !1,
        isDialogOpen: !1,
        isDisabled: !1,
        isFitContainerWidthEnabled: !1,
        isFocused: !1,
        isInvalid: !1,
        isLoading: !1,
        isPaddingDisabled: !1,
        isReadOnly: !1,
        isRequired: !1,
        onDialogBlur: function() {},
        onDialogClick: function() {},
        onDialogFocus: function() {},
        shouldReset: !1
    }, exports.default = FieldBaseStateless;
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/inline-dialog");
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.ContentWrapper = exports.Content = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(10), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n    border-width: ", "px;\n    padding: ", ";\n  " ], [ "\n    border-width: ", "px;\n    padding: ", ";\n  " ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  color: ", ";\n  pointer-events: none;\n" ], [ "\n  color: ", ";\n  pointer-events: none;\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  " ], [ "\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  " ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "margin: -", "px" ], [ "margin: -", "px" ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  ", "\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-style: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  font-size: ", "px;\n  justify-content: space-between;\n  line-height: ", ";\n  max-width: 100%;\n  min-height: ", "px;\n  overflow: hidden;\n  transition:\n    background-color ", " ease-in-out,\n    border-color ", " ease-in-out;\n  word-wrap: break-word;\n\n  ", "\n  ", "\n" ], [ "\n  ", "\n  ", "\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-style: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  font-size: ", "px;\n  justify-content: space-between;\n  line-height: ", ";\n  max-width: 100%;\n  min-height: ", "px;\n  overflow: hidden;\n  transition:\n    background-color ", " ease-in-out,\n    border-color ", " ease-in-out;\n  word-wrap: break-word;\n\n  ", "\n  ", "\n" ]), _templateObject6 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  ", ";\n  align-items: center;\n  display: flex;\n  max-width: 100%;\n" ], [ "\n  ", "\n  ", ";\n  align-items: center;\n  display: flex;\n  max-width: 100%;\n" ]), _styledComponents = __webpack_require__(11), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(14), _theme = __webpack_require__(15), _theme2 = _interopRequireDefault(_theme), borderRadius = "5px", borderWidth = 1, borderWidthFocused = 2, borderWidthSubtle = 0, fontSize = 14, heightBase = 5 * _utilSharedStyles.akGridSizeUnitless, heightCompact = 4 * _utilSharedStyles.akGridSizeUnitless, horizontalPadding = _utilSharedStyles.akGridSizeUnitless, innerHeight = 2.5 * _utilSharedStyles.akGridSizeUnitless, lineHeight = innerHeight / fontSize, transitionDuration = "0.2s", getBorderAndPadding = function(_ref) {
        var paddingDisabled = _ref.paddingDisabled, invalid = _ref.invalid, focused = _ref.focused, compact = _ref.compact, subtle = _ref.subtle, none = _ref.none, border = void 0, height = compact ? heightCompact : heightBase;
        border = invalid || focused || none ? borderWidthFocused : subtle ? borderWidthSubtle : borderWidth;
        var padding = paddingDisabled ? 0 : (height - 2 * border - innerHeight) / 2 + "px " + (horizontalPadding - border) + "px";
        return (0, _styledComponents.css)(_templateObject, border, padding);
    }, getDisabledState = function(_ref2) {
        var disabled = _ref2.disabled;
        return disabled && (0, _styledComponents.css)(_templateObject2, _theme2.default.field.disabled.text.default);
    }, getHoverState = function(_ref3) {
        var appearance = _ref3.appearance, readOnly = _ref3.readOnly, focused = _ref3.focused, none = _ref3.none;
        return readOnly || focused || none ? null : (0, _styledComponents.css)(_templateObject3, _theme2.default.field[appearance].background.hover, _theme2.default.field[appearance].border.hover);
    }, getMargin = function(_ref4) {
        var appearance = _ref4.appearance, focused = _ref4.focused, paddingDisabled = _ref4.paddingDisabled, readOnly = _ref4.readOnly;
        if (!focused || "invalid" !== appearance || "none" === appearance || !paddingDisabled || readOnly) return null;
        var margin = "subtle" === appearance ? borderWidthFocused : borderWidth;
        return (0, _styledComponents.css)(_templateObject4, margin);
    }, getBackgroundColor = function(_ref5) {
        var appearance = _ref5.appearance, focused = _ref5.focused, state = focused ? "focus" : "default";
        return _theme2.default.field[appearance].background[state];
    }, getBorderColor = function(_ref6) {
        var appearance = _ref6.appearance, focused = _ref6.focused, state = focused ? "focus" : "default";
        return _theme2.default.field[appearance].border[state];
    };
    exports.Content = _styledComponents2.default.div(_templateObject5, function(p) {
        return getBorderAndPadding(p);
    }, function(p) {
        return getMargin(p);
    }, function(p) {
        return getBackgroundColor(p);
    }, function(p) {
        return getBorderColor(p);
    }, borderRadius, function(p) {
        return "none" === p.appearance ? "none" : "solid";
    }, fontSize, lineHeight, innerHeight, transitionDuration, transitionDuration, function(p) {
        return getHoverState(p);
    }, function(p) {
        return getDisabledState(p);
    }), exports.ContentWrapper = _styledComponents2.default.div(_templateObject6, function(p) {
        return p.disabled && "cursor: not-allowed;";
    }, function(p) {
        return p.grow && "flex: 1 1 auto;";
    });
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _utilSharedStyles = __webpack_require__(14), invalidColor = _utilSharedStyles.akColorY300;
    exports.default = {
        field: {
            standard: {
                background: {
                    default: _utilSharedStyles.akColorN10,
                    focus: _utilSharedStyles.akColorN0,
                    hover: _utilSharedStyles.akColorN20
                },
                border: {
                    default: _utilSharedStyles.akColorN20,
                    focus: _utilSharedStyles.akColorB100,
                    hover: _utilSharedStyles.akColorN20
                }
            },
            disabled: {
                background: {
                    default: _utilSharedStyles.akColorN20,
                    focus: _utilSharedStyles.akColorN20,
                    hover: _utilSharedStyles.akColorN20
                },
                border: {
                    default: _utilSharedStyles.akColorN20A,
                    focus: _utilSharedStyles.akColorN20A,
                    hover: _utilSharedStyles.akColorN20A
                },
                text: {
                    default: _utilSharedStyles.akColorN60,
                    focus: _utilSharedStyles.akColorN60,
                    hover: _utilSharedStyles.akColorN60
                }
            },
            invalid: {
                background: {
                    default: _utilSharedStyles.akColorN10,
                    focus: _utilSharedStyles.akColorN0,
                    hover: _utilSharedStyles.akColorN20
                },
                border: {
                    default: invalidColor,
                    hover: invalidColor,
                    focus: invalidColor
                }
            },
            subtle: {
                background: {
                    default: "transparent",
                    focus: _utilSharedStyles.akColorN0,
                    hover: _utilSharedStyles.akColorN20
                },
                border: {
                    default: "transparent",
                    focus: _utilSharedStyles.akColorB100,
                    hover: _utilSharedStyles.akColorN20
                }
            },
            none: {
                background: {
                    default: "transparent",
                    focus: "transparent",
                    hover: "transparent"
                },
                border: {
                    default: "transparent",
                    focus: "transparent",
                    hover: "transparent"
                }
            }
        },
        icon: {
            color: invalidColor
        },
        label: {
            color: _utilSharedStyles.akColorN200
        }
    };
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.WarningIcon = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(10), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: center;\n  color: ", ";\n  display: flex;\n" ], [ "\n  align-items: center;\n  color: ", ";\n  display: flex;\n" ]), _styledComponents = __webpack_require__(11), _styledComponents2 = _interopRequireDefault(_styledComponents), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(8), _propTypes2 = _interopRequireDefault(_propTypes), _spinner = __webpack_require__(17), _spinner2 = _interopRequireDefault(_spinner), _warning = __webpack_require__(18), _warning2 = _interopRequireDefault(_warning), _theme = __webpack_require__(15), _theme2 = _interopRequireDefault(_theme), WarningIcon = exports.WarningIcon = _styledComponents2.default.div(_templateObject, _theme2.default.icon.color), ValidationElement = function(_ref) {
        var isDisabled = _ref.isDisabled, isInvalid = _ref.isInvalid, isLoading = _ref.isLoading;
        return !isDisabled && isInvalid ? _react2.default.createElement(WarningIcon, null, _react2.default.createElement(_warning2.default, {
            label: "warning",
            size: "medium"
        })) : isLoading ? _react2.default.createElement(_spinner2.default, null) : null;
    };
    ValidationElement.propTypes = {
        isDisabled: _propTypes2.default.bool,
        isInvalid: _propTypes2.default.bool,
        isLoading: _propTypes2.default.bool
    }, exports.default = ValidationElement;
}, /* 17 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/spinner");
}, /* 18 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/icon/glyph/warning");
}, /* 19 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(4), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(5), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(6), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(8), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _Label = __webpack_require__(20), Label = function(_PureComponent) {
        function Label() {
            return (0, _classCallCheck3.default)(this, Label), (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
        }
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        return (0, _inherits3.default)(Label, _PureComponent), Label.prototype.render = function() {
            var _props = this.props, appearance = _props.appearance, children = _props.children, htmlFor = _props.htmlFor, isFirstChild = _props.isFirstChild, isLabelHidden = _props.isLabelHidden, isRequired = _props.isRequired, label = _props.label, onClick = _props.onClick;
            return _react2.default.createElement(_Label.LabelWrapper, {
                htmlFor: htmlFor
            }, _react2.default.createElement(_Label.LabelInner, {
                isHidden: isLabelHidden,
                inlineEdit: "inline-edit" === appearance,
                firstChild: isFirstChild
            }, _react2.default.createElement("span", {
                onClick: onClick
            }, label), isRequired ? _react2.default.createElement(_Label.RequiredIndicator, {
                role: "presentation"
            }, "*") : null), children);
        }, Label;
    }(_react.PureComponent);
    Label.propTypes = {
        /** the label text to display */
        label: _propTypes2.default.string.isRequired,
        /** whether to hide the label */
        isLabelHidden: _propTypes2.default.bool,
        /** onclick handler */
        onClick: _propTypes2.default.func,
        /** show a style indicating that the label is for a required field */
        isRequired: _propTypes2.default.bool,
        /** the labels control element */
        htmlFor: _propTypes2.default.string,
        /** any children to render, displayed underneath the label */
        children: _propTypes2.default.node,
        /** controls the appearance of the label */
        appearance: _propTypes2.default.oneOf([ "default", "inline-edit" ]),
        /** controls the top margin of the label */
        isFirstChild: _propTypes2.default.bool
    }, Label.defaultProps = {
        appearance: "default"
    }, exports.default = Label;
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.RequiredIndicator = exports.LabelInner = exports.LabelWrapper = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(10), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "padding: ", "px ", "px ", "px ", "px" ], [ "padding: ", "px ", "px ", "px ", "px" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: block;\n" ], [ "\n  display: block;\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  color: ", ";\n  font-size: ", "px;\n  font-weight: 600;\n  line-height: ", "\n  ", "\n\n  ", "\n" ], [ "\n  color: ", ";\n  font-size: ", "px;\n  font-weight: 600;\n  line-height: ", "\n  ", "\n\n  ", "\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  color: ", ";\n  padding-left: 2px;\n" ], [ "\n  color: ", ";\n  padding-left: 2px;\n" ]), _styledComponents = __webpack_require__(11), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(14), _theme = __webpack_require__(15), _theme2 = _interopRequireDefault(_theme), fontSize = 12, innerHeight = 2 * _utilSharedStyles.akGridSizeUnitless, lineHeight = innerHeight / fontSize, getPadding = function(_ref) {
        var firstChild = _ref.firstChild, inlineEdit = _ref.inlineEdit, right = 0, bottom = _utilSharedStyles.akGridSizeUnitless / 2, left = 0, top = 2.5 * _utilSharedStyles.akGridSizeUnitless;
        return inlineEdit && (bottom = 0, left = _utilSharedStyles.akGridSizeUnitless, top = _utilSharedStyles.akGridSizeUnitless), 
        firstChild && (top = _utilSharedStyles.akGridSizeUnitless / 2), (0, _styledComponents.css)(_templateObject, top, right, bottom, left);
    };
    exports.LabelWrapper = _styledComponents2.default.label(_templateObject2), exports.LabelInner = _styledComponents2.default.div(_templateObject3, _theme2.default.label.color, fontSize, lineHeight, getPadding, function(p) {
        return p.isHidden && "display: none;";
    }), exports.RequiredIndicator = _styledComponents2.default.span(_templateObject4, _utilSharedStyles.akColorR300);
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/field-base/dist/bundle-cjs.js
// module id = 347
// module chunks = 0